var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWsp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "4961.000000pt",
    height: "2435.000000pt",
    viewBox: "0 0 4961.000000 2435.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,2435.000000) scale(0.100000,-0.100000)",
    fill: "#FF0000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1023 23368 c2 -7 1012 -2746 2243 -6085 l2239 -6073 871 0 c688 0 873 3 877 13 2 6 174 473 382 1036 l377 1024 -1847 5011 c-1016 2756 -1854 5028 -1862 5049 l-15 37 -1635 0 c-1304 0 -1634 -3 -1630 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9803 23368 c2 -7 1012 -2746 2243 -6085 l2239 -6073 872 0 871 0 10 28 c5 15 175 475 377 1022 202 547 370 1002 372 1010 3 11 -3609 9829 -3712 10093 -7 16 -94 17 -1642 17 -1304 0 -1634 -3 -1630 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20505 23305 c-151 -330 -285 -853 -350 -1360 -49 -387 -68 -899 -46 -1220 65 -927 327 -1685 796 -2305 311 -410 856 -903 1401 -1267 528 -353 1006 -601 2109 -1093 1133 -506 1605 -747 2110 -1078 1069 -700 1530 -1469 1431 -2387 -45 -423 -195 -893 -405 -1277 l-59 -108 1470 0 1469 0 41 87 c146 315 260 669 337 1043 125 613 154 1392 75 2015 -126 985 -551 1839 -1294 2599 -552 564 -1122 963 -2030 1420 -538 271 -811 395 -1481 671 -557 230 -720 302 -999 441 -522 261 -899 522 -1226 848 -171 171 -256 272 -358 426 -317 475 -460 1034 -406 1581 33 330 128 674 261 942 l48 97 -1430 0 -1430 0 -34 -75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34940 12130 l0 -11250 1565 0 1565 0 0 11250 0 11250 -1565 0 -1565 0 0 -11250z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42955 23338 c938 -1097 1603 -2494 1914 -4018 247 -1215 268 -2487 61 -3717 -273 -1618 -951 -3130 -1921 -4280 l-91 -108 1772 -3 c1492 -2 1775 0 1784 12 6 7 63 83 127 167 812 1075 1413 2686 1644 4410 102 766 127 1580 70 2324 -153 1992 -802 3892 -1752 5133 l-94 122 -1775 0 -1776 0 37 -42z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsp);
export default __webpack_public_path__ + "static/media/wsp.b6f4f45812e5a9c2cd76e114fddd366a.svg";
export { ForwardRef as ReactComponent };